export const channelOptions = [
  { label: 'New Qualy', value: 'new-qualy' },
  { label: 'Parceria', value: 'partner' },
  { label: 'Associações', value: 'association' },
  { label: 'Digital', value: 'digital' }
]
